import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import clsx from 'clsx'

const TourStepper = ({ className = '', currentStep = 0, steps }) => {
  const dividers = Array(steps.length).fill(undefined)

  return (
    <div className='inline-flex w-full flex-col items-start justify-start gap-6'>
      <div className='text-text-default text-lg font-medium leading-[27px]'>Complete these quick steps</div>
      <div className={`relative flex w-full flex-row ${className}`}>
        <div
          className={clsx(
            `relative z-[1] flex w-full flex-row md:flex-col`,
            steps.length === 1 ? 'justify-center' : 'justify-between'
          )}
        >
          {dividers.map((_, step) => (
            <span
              className='relative flex flex-col items-center pb-6 last:pb-0 md:flex-row md:!pb-12 md:last:!pb-0'
              key={step}
            >
              <div
                className={clsx(
                  `flex h-6 w-6 items-center justify-center rounded-full border-2 text-center text-sm leading-none `,
                  currentStep < step ? 'border-border-muted bg-background-default text-text-alternative' : '',
                  currentStep === step ? 'bg-background-default border-primary-default text-primary-default' : '',
                  currentStep > step ? 'bg-primary border-primary-default bg-primary-default text-primary-inverse' : ''
                )}
              >
                <span className='m-auto text-base'>{step + 1}</span>
              </div>
              <span
                className={clsx(
                  'absolute left-0 top-[30px] line-clamp-2 hidden text-center text-sm font-medium md:relative md:!top-0 md:!ml-2 md:!inline',
                  currentStep >= step ? 'text-primary-default' : '',
                  currentStep < step ? 'text-text-alternative' : ''
                )}
              >
                {steps[step].label}
              </span>
              <span className='absolute left-0 top-[30px] -ml-[40px] line-clamp-2 w-[100px] text-center text-sm md:hidden'>
                <FontAwesomeIcon icon={steps[step].icon} />
              </span>
            </span>
          ))}
        </div>
        <div className='absolute left-0 right-0 top-3 m-auto flex w-full flex-row flex-nowrap md:!bottom-0 md:!left-[11px] md:!top-0 md:!flex-col'>
          {dividers.slice(1).map((_, index) => (
            <div
              className={clsx(
                'b-8 flex-grow border-0 border-t-2 md:!border-l-2 md:!border-t-0',
                ` ${index < currentStep ? 'border-primary-default' : 'border-border-muted'}`
              )}
              key={index}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TourStepper
